import React from 'react'

const Index = () => {
  return (
    <div>This is an error 404 page</div>
  )
}

export default Index